import React, { useContext, useState,useEffect } from 'react';
import styles from './setting.module.css'
import Switch from "react-switch";
import {BiArrowBack  } from "react-icons/bi";
import {GiCancel} from 'react-icons/gi'
import { Link } from 'react-router-dom';
import axios from 'axios';
import { UserContext } from '../../../context/userContext';
import { toast } from 'react-toastify';
import ReactLoading from 'react-loading';


const Profileset=()=>{
    const{user}=useContext(UserContext);
    const[tooltip,setTooltip]=useState(false);
    const [toggle,setToggle]=useState(false);
    const [phone,setPhone]=useState("");
    const [opt,setOtp]=useState("");
    const[email,setEmail]=useState("");
    const [settingDialog,setSettindDialog]=useState(false);
    const [cpassword,setCpassword]=useState("");
    const [npassword,setNpassword]=useState("");
    const [cnpassword,setCnpassword]=useState("");
    const [passChangeLoading,setPassChangeLoading]=useState(false);
    const [toggleLoading,setToggleLoading]=useState(false)

const chnagePassword=()=>{
  
if(npassword===cnpassword){
    setPassChangeLoading(true)
    axios.post("https://vsam.me/api/api.php?request=loginPasswordReset",{
        user_id:user.userid,
        token:user.token,
        current_password:cpassword,
        new_password:npassword,
        confirm_password:cnpassword

    }).then(res=>{
        if(res.data.status){
            toast.success(res.data.msg)
            setNpassword("");
            setCnpassword("");
            setCpassword("");
            setSettindDialog(false);
            setPassChangeLoading(false)
        }else{
            toast.error(res.data.msg)
            setPassChangeLoading(false)
        }


    }).catch(err=>{
        setPassChangeLoading(false)
    })
}else{
    toast.warning("New password and Confirm password did not match")
}
}
const hangleProfileToggle=()=>{
    setToggleLoading(true)
    axios.post("https://vsam.me/api/api.php?request=toggleProfileType",{
        user_id:user.userid,
        token:user.token,

    }).then(res=>{
        toast.success(res.data.msg)
        getProfiletype()
        setToggleLoading(false)
       })


}

function getProfiletype(){
    setToggleLoading(true)
    axios.post("https://vsam.me/api/api.php?request=getProfileType",{
        user_id:user.userid,
        token:user.token,

    }).then(res=>{
        
        setToggle(res.data.msg.isPrivate)
        setToggleLoading(false)
    
    })

}

useEffect(() => {
    getProfiletype();

}, [])



    return(
        <div>
            <div  className={styles.backbtn} >
            <Link to="/setting">
           <BiArrowBack/>
           
         </Link>
         <span>Profile Setting</span>
         </div>
            <div className={styles.personalsetting}>
              
                
                <div className={styles.pvt}>
                  
            <label 
            onMouseEnter={()=>setTooltip(true)}
            onMouseLeave={()=>setTooltip(false)}
            className={styles.actypelabel} >Private Account</label>   
       
        
        {toggleLoading?
        <ReactLoading type={"balls"} color={"blue"}  height={40} width={40} />:
        
     <Switch 
         onColor="#C19AE6"
         onHandleColor="#7124BD"
         onChange={hangleProfileToggle} checked={toggle} />}



       {tooltip?
       <span className={styles.tooltiptext}>In private ac none of your user can see you your post with out follow you</span>
      :""}
          </div>
          <br/>




                <div className={styles.inputNumber}>
                <div>Phone</div>
                <input maxLength="10" value={phone} type="tel" onChange={(e)=>setPhone(e.target.value)} />
                <div className={styles.opt}>
                 {phone.length===10? 
                 <>  
                <button className={styles.obtn}>Send opt</button>
                <input placeholder="4 digit OTP" onChange={e=>setOtp(e.target.value)} value={opt} maxLength="4" />
                </>
                :""}
                </div>
                </div>
                    <br/>
                <div className={styles.inputNumber}>
                <div>Email</div>
                <input value={email} type="emial" onChange={(e)=>setEmail(e.target.value)} />
                <div className={styles.opt}>
                 {email.length>3? 
                 <>  
                <button className={styles.obtn}>Send opt</button>
                <input placeholder="4 digit OTP" onChange={e=>setOtp(e.target.value)} value={opt} maxLength="4" />
                </>
                :""}
                </div>
                </div>


                <div className={styles.dob}>
                <label>Date of Birth:</label>
                <input type="date"/>
                  </div>  
            </div>
                    {settingDialog?
                    <dialog className={styles.passwordreserdialog} open>
                    <div className={styles.dialogicon}><GiCancel onClick={()=>setSettindDialog(false)} /></div>
                    <div>Current Password</div>
                    <input type="password" value={cpassword} onChange={e=>setCpassword(e.target.value)}  />
                        <br/><br/><br/>
                    <div>New Password</div>
                    <input type="password" value={npassword} onChange={e=>setNpassword(e.target.value)} />
                    <br/><br/><br/> 
                    <div>Confirm New Password</div>
                    <input type="password"  value={cnpassword} onChange={e=>setCnpassword(e.target.value)} />
                    <br/><br/><br/>
                   <div className={styles.profileButtons}>
                        {passChangeLoading?
                   <ReactLoading type={"balls"} color={"#7124BD"}  height={40} width={40} />
                            :
                       <button style={{width:"200px"}} onClick={chnagePassword} >Change Password  </button>    
                        }
                       </div>
                    </dialog>:""}



            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <div className={styles.profileButtons}>
                <div>
                <button onClick={()=>setSettindDialog(true)} >Reset Password</button>
                <button>Disable Account</button>
                <button>Delete Account</button>
                    </div>
            </div>
           

        </div>
    )
}

export default Profileset;